import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { getAdminShipments } from '../../actions/shipment'

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import IconCard from "components/Cards/IconCard.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

import locationsPageStyle from "assets/jss/material-dashboard-pro-react/views/locationsPageStyle.jsx";


class Shipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipments: [],
    };
  }

  handleTableAction(action, id){
    if(action==="delete"){
    }  
    if(action==="edit"){
    }
  }

  componentDidMount() {
    this.props.dispatchGetAdminShipments(this.props.auth.user)
    .then( shipments => {
      this.setState({shipments});
    });   
  }
  render() {
    const {  translate, classes } = this.props;

    var tableData = [];
    if(this.state.shipments.length>0){
      this.state.shipments.map((prop,key)=>{
        
        let fillButtons = [
          { color: "info", icon: Person, action:"view" },
          { color: "success", icon: Edit, action: "edit" },
          { color: "danger", icon: Close, action: "delete" }
        ].map((button, buttonKey) => {
          return (
            <Button color={button.color} customClass={classes.actionButton} onClick={() => this.handleTableAction(button.action, prop.id)} key={buttonKey}>
              <button.icon className={classes.icon} />
            </Button>
          );
        });
        tableData.push([prop.id, prop.customer, prop.receiver, prop.location, prop.shipmentCarrier, fillButtons]);
        return false;
      });
    }

    return (
      <div>
        <GridContainer>
          {this.state.alert}        
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.admin_shipments.content")} /> 
          </ItemGrid>                
          <ItemGrid xs={12} sm={12} md={12}>
            <IconCard
              icon={Assignment}
              iconColor="rose"
              title="Shipments"
              content={
                <Table
                  tableHead={[
                    "Id",
                    "Customer",
                    "Receiver",
                    "Location Nickname",
                    "Shipment Carrier",
                    "Actions"
                  ]}
                  tableData={tableData}
                />
              }
            />
          </ItemGrid>                    
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchGetAdminShipments: (user) => getAdminShipments(user),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
  }
}


export default compose(
  withStyles(locationsPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(Shipments);



// WEBPACK FOOTER //
// ./src/views/Admin/Shipments.jsx